var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrcBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 32,
    viewBox: "0 0 86 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5059 0.568978H15.6861H10.7529L4.93316 0.591738H0V8.92175H4.93316V5.50781H10.7757L10.7984 27.0612L7.68391 27.0839V32L18.846 31.9772V27.0612H15.7316L15.6861 5.50781L21.5286 5.48505V8.73968H26.439V0.546219H26.4163L21.5059 0.568978Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M53.082 18.3898H53.1729L53.1502 18.367L56.9012 14.5889V4.165L53.2184 0.523468H51.9453L38.4416 0.546228H33.5085H30.4395V5.48506H33.5085L33.5539 27.0384H30.4395V31.9772H41.6016V27.0384H38.4871V18.4353H48.1943L50.6268 27.0156H48.7626V31.9545H52.0135H56.9467H59.9248V27.0156H55.5599L53.1274 18.4125L53.082 18.3898ZM51.9453 13.4509H38.4416V5.43954H51.9453V13.4509Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M85.0691 8.64864V3.86913L81.6364 0.455185H80.136L68.8147 0.477945H67.5189L63.9043 4.11948V5.41678V8.83072L63.927 17.4794V19.1863V26.9701V27.3115L63.9498 28.3129L67.5416 31.909L80.1815 31.8862H81.7273L85.1146 28.495L85.0919 23.6927H80.1815V26.9474L68.8602 26.9701L68.8375 8.80796L68.8147 5.41678L80.136 5.39402L80.1587 8.64864H85.0691Z",
    fill: "#F26522"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrcBig);
export default __webpack_public_path__ + "static/media/TRC_Big.4e70a542c56977418e87cc824511bee2.svg";
export { ForwardRef as ReactComponent };